// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	production: false,
	// base_url: 'http://localhost:8000',
	base_url: 'https://agence01-api.n2m-solution.com',
	base_url_front: 'https://agence01.n2m-solution.com/#',
	external_url: 'https://agence01.n2m-solution.com/gestion/',
	external_url_redirect: 'https://agence01.n2m-solution.com/gestion/url/redirect.php',
	// base_url: 'https://atmosphere-api.agence01.fr',
	// base_url_front: 'https://atmosphere.agence01.fr/#',
	// external_url: 'https://atmosphere.agence01.fr/gestion/',
	// external_url_redirect: 'https://atmosphere.agence01.fr/gestion/url/redirect.php'
};

/*
* For easier debugging in development mode, you can import the following file
* to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
*
* This import should be commented out in production mode because it will have a negative impact
* on performance if an error is thrown.
*/
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
